
export class BookingsPerServiceReportData {

    constructor(
        public date: string,
        public serviceId: string | null,
        public serviceName: string,
        public totalBookings: number,
        public totalCovers: number,
        public customerBookings: number,
        public customerCovers: number,
        public merchantBookings: number,
        public merchantCovers: number,
        public walkinBookings: number,
        public walkinCovers: number
    ) { }
}
